<div [formGroup]="gs.gastroForm">
  <div class="h100 w100 l-flex-w summary">


  <app-gastro-summary [hideSignature]="true"></app-gastro-summary>

      <app-exam-diagnoses></app-exam-diagnoses>

      <div class="w100 summary">
        <section class="m-box">
          <h2>Summary of Exam</h2>
          <angular-editor formControlName="Summary" [config]="editorConfig" style="width: 100%"></angular-editor>
          <button class="t-btn-edit" *ngIf="! es.isClosed" (click)="atS.showAuto(gs.gastroForm.get('Summary')!,'Summary',712, true, true)">Auto Text</button>

        </section>
      </div>

      <!-- =============== Exam Signature (Start) =============== -->
      <app-gastro-summary [signOnly]="true"></app-gastro-summary>
      <!-- =============== Exam Signature (End) =============== -->
    </div>
</div>
